<form action="#" method="post" id="d2" class="aui top-label">
  <fieldset>
    <div class="field-group" bis_skin_checked="1">
      <label for="name">Hubstaff account</label>
      <input class="text" type="text" id="name" value="{{ me?.name }}" name="name" title="name" readonly />
    </div>
    <div class="buttons-container">
      <div class="buttons">
        <app-button (clickHandler)="removeToken($event)" [iconType]="IconTypes.Trash" [iconClasses]="'delete'">
          <!-- <app-icon [type]="IconTypesEnum.Trash" [classNames]="'delete'"></app-icon> -->
          Remove token
        </app-button>
        <app-button [classNames]="'aui-button-link cancel'" (clickHandler)="cancelRedirect()">Cancel</app-button>
      </div>
    </div>
  </fieldset>
</form>
